"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseProductCreate = void 0;
function parseProductCreate(data) {
    if (typeof data.creation_date === 'string')
        data.creation_date = new Date(data.creation_date);
    return data;
}
exports.parseProductCreate = parseProductCreate;
